// Use the first non-manual value
// If there are no non-manual values use the first manual value
const getInitialValueForLinkedFields = ({
  fieldKeys,
  formMethods,
  getResponseSource,
}: {
  fieldKeys: string[];
  formMethods: { getValues: (key: string) => unknown };
  getResponseSource: (key: string) => unknown;
}): { value: unknown; key: string } | null => {
  let value: unknown = null;
  let usedFieldKey: string | null = null;
  for (let i = 0; i < fieldKeys.length; i += 1) {
    const fieldKey = fieldKeys[i];
    value = formMethods.getValues(fieldKey);

    if (value !== null && value !== undefined) {
      const source = getResponseSource(fieldKey);

      if (source && source !== 'manual') {
        return { key: fieldKey, value };
      }

      if (!usedFieldKey) {
        usedFieldKey = fieldKey;
      }
    }
  }

  return usedFieldKey ? { key: usedFieldKey, value } : null;
};

export default getInitialValueForLinkedFields;